export default "__VITE_ASSET__D3UQ2GBb__"